<a *ngIf="uid" ngxClipboard [cbContent]="uid" (cbOnSuccess)="uidCopied(uid)" [attr.title]="linkTextKey | translate">
  <ng-container *ngIf="showIcon">
    <i class="ui icon copy outline"></i>
  </ng-container>
  <ng-container *ngIf="showText">
    {{ linkTextKey | translate }}
  </ng-container>
</a>
